import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import RequestQuotePopup from '../../../components/feature/RequestQuotePopup';

export default function TakeoffServices() {
  const [quoteService, setQuoteService] = useState<string | null>(null);
  const [takeoffServices, setTakeoffServices] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch("https://partner.designsbydmi.com/api/cms/services/takeoff");
        const data = await response.json();
        setTakeoffServices(data);
      } catch (error) {
        console.error("Failed to fetch takeoff services", error);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  return (
    <>
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-flex items-center gap-2 bg-orange-50 text-[#e18033] px-4 py-2 rounded-full text-sm font-semibold mb-4">
              <i className="ri-calculator-line"></i>
              <span>3 Core Services</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Accurate Takeoff &amp; Estimation
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Precise quantity takeoffs and cost analysis to help you bid competitively and manage project budgets effectively
            </p>
          </div>

          <div className="space-y-8">
            {loading ? (
              Array.from({ length: 3 }).map((_, i) => (
                <div key={i} className="animate-pulse bg-white dark:bg-slate-800 rounded-2xl h-96 shadow-sm w-full"></div>
              ))
            ) : takeoffServices.length > 0 ? (
              takeoffServices.map((service, index) => (
                <Link
                  to={`/service/${service.title.toLowerCase().replace(/\s+/g, '-').replace(/[&/]/g, '')}`}
                  key={service.id}
                  className={`bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                    } flex flex-col lg:flex cursor-pointer group block`}
                >
                  <div className="lg:w-1/2 h-80 lg:h-auto w-full">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-contain object-center p-4"
                    />
                  </div>
  
                  <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center">
                    <div className="inline-flex items-center gap-2 bg-orange-50 text-[#e18033] px-3 py-1.5 rounded-full text-xs font-semibold mb-4 w-fit">
                      <span>Service {service.id}</span>
                    </div>
  
                    <h3 className="text-3xl font-bold text-gray-900 mb-4">
                      {service.title}
                    </h3>
  
                    <p className="text-base text-gray-600 mb-6 leading-relaxed whitespace-pre-line">
                      {service.description}
                    </p>
  
                    <div className="grid grid-cols-2 gap-3 mb-6">
                      {service.features && service.features.map((feature: string, idx: number) => (
                        <div key={idx} className="flex items-start gap-2">
                          <i className="ri-check-line text-[#e18033] text-lg mt-0.5 flex-shrink-0"></i>
                          <span className="text-sm text-gray-700">{feature}</span>
                        </div>
                      ))}
                    </div>
  
                    <div className="flex flex-wrap gap-2 mb-6">
                      {service.tags && service.tags.map((tag: string, idx: number) => (
                        <span
                          key={idx}
                          className="text-xs bg-gray-100 text-gray-700 px-3 py-1.5 rounded-full"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
  
                    <div className="mt-auto pt-6 border-t border-gray-50 flex justify-between items-center">
                      <span className="text-[#e18033] font-semibold text-sm group-hover:text-[#c97029] transition-colors">
                        View Details <i className="ri-arrow-right-line ml-1 transition-transform group-hover:translate-x-1"></i>
                      </span>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setQuoteService(service.title);
                        }}
                        className="inline-flex items-center text-gray-500 hover:text-[#e18033] font-semibold text-sm transition-colors z-10 relative px-4 py-2 rounded-md hover:bg-orange-50"
                      >
                        Request Quote
                      </button>
                    </div>
                  </div>
                </Link>
              ))
            ) : (
              <p className="text-center text-gray-500 py-10">No takeoff services found.</p>
            )}
          </div>
        </div>
      </section>

      {/* Request Quote Popup */}
      <RequestQuotePopup
        isOpen={!!quoteService}
        onClose={() => setQuoteService(null)}
        serviceName={quoteService || undefined}
      />
    </>
  );
}
